import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import background from "../assets/background.webp";
import mainOfficeImg from "../assets/branches/center.jpg";
import qararatImg from "../assets/branches/q-ararat.jpg";
import callCentreImg from "../assets/branches/call-centre.jpg";
import gAraratImg from "../assets/branches/g-ararat.jpg";
import ejmiacinImg from "../assets/branches/ejmiacin.jpg";
import armavirImg from "../assets/branches/armavir.jpg";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
const BranchesPage = () => {
  const { t } = useTranslation();
  const branches = t("branches_list", { returnObjects: true });
  const [selectedIdx, setSelectedIdx] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const selectedBranch = branches?.[selectedIdx];
  const branchImages = {
    0: mainOfficeImg,
    1: qararatImg,
    2: callCentreImg,
    3: gAraratImg,
    4: ejmiacinImg,
    5: armavirImg,
  };
  const selectedImage = branchImages[selectedIdx];

  return (
    <section
      style={{ backgroundImage: `url(${background})` }}
      className="w-full min-h-screen bg-slate-800 bg-cover bg-center text-white py-24 max-sm:py-6 px-4"
    >
      <div className="max-w-7xl mx-auto">
        <div className={`text-center pt-10 mb-12 transition-all duration-500 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <h1 className="text-[22px] md:text-[64px] uppercase tracking-[0.15em] font-['Cormorant_Garamond']">
            {t("branches_page_title")}
          </h1>
          <p className="text-yellow-400 tracking-[0.15em] mt-4 text-sm md:text-base">
            {t("branches_page_subtitle")}
          </p>
        </div>

        <div className={`grid grid-cols-1  lg:grid-cols-2 gap-8 transition-all duration-500 delay-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <div className={`bg-[#1e293b]/80 backdrop-blur-sm rounded-2xl p-4 md:p-6 border max-sm:order-1 border-white/10 transition-all duration-500 delay-500 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <p className="text-white/70 mb-4 text-sm">{t("branches_select_prompt")}</p>
            
            {/* Mobile: Swiper */}
            <div className="block md:hidden">
              <Swiper
                spaceBetween={10}
                slidesPerView={1.2}
                centeredSlides={false}
                className="pb-4"
              >
                {branches?.map((branch, idx) => (
                  <SwiperSlide key={`${branch.name}-${idx}`}>
                    <button
                      onClick={() => setSelectedIdx(idx)}
                      className={`w-full text-left p-4 rounded-xl border transition-all ${
                        idx === selectedIdx
                          ? "bg-yellow-400 text-black border-yellow-300"
                          : "bg-white/5 text-white border-white/10 hover:bg-white/10"
                      }`}
                    >
                      <p className="font-semibold max-sm:text-sm uppercase tracking-[0.08em]">{branch.name}</p>
                    </button>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>

            {/* Desktop: Grid */}
            <div className="hidden md:grid grid-cols-1 gap-3">
              {branches?.map((branch, idx) => (
                <button
                  key={`${branch.name}-${idx}`}
                  onClick={() => setSelectedIdx(idx)}
                  className={`text-left p-4 rounded-xl border transition-all ${
                    idx === selectedIdx
                      ? "bg-yellow-400 text-black border-yellow-300"
                      : "bg-white/5 text-white border-white/10 hover:bg-white/10"
                  }`}
                >
                  <p className="font-semibold uppercase tracking-[0.08em]">{branch.name}</p>
                </button>
              ))}
            </div>
          </div>

          <div className={`bg-[#1e293b]/80 backdrop-blur-sm rounded-2xl p-6 md:p-8 border border-white/10 flex flex-col gap-5 transition-all duration-500 delay-200 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <h2 className="text-[20px] md:text-[34px] text-yellow-400 uppercase tracking-[0.08em] font-['Cormorant_Garamond']">
              {selectedBranch?.name}
            </h2>

            {selectedImage && (
              <div className="w-full overflow-hidden rounded-xl border border-white/10 shadow-2xl">
                <img
                  src={selectedImage}
                  alt={selectedBranch?.name}
                  className="w-full h-[220px] md:h-[350px] object-cover"
                />
              </div>
            )}

            <div className="text-white/90 leading-7">
              <span className="text-yellow-400 uppercase tracking-[0.1em] text-sm">
                {t("branches_address_label")}:
              </span>
              <p className="mt-2 text-[16px]">{selectedBranch?.address}</p>
            </div>

            <a
              href={selectedBranch?.mapUrl}
              target="_blank"
              rel="noreferrer"
              className="inline-block mt-2 w-fit px-6 py-3 bg-yellow-400 text-black uppercase tracking-[0.15em] rounded-lg hover:bg-yellow-300 transition"
            >
              {t("branches_open_map")}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BranchesPage;
